import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Plus, Minus } from "lucide-react";

const FALLBACK_FAQS = [
  { _id: "f1", question: "How do I book a consultation?", answer: "Use the Book a Consultation page to choose a time, pay your non-refundable deposit, and complete the intake form." },
  { _id: "f2", question: "Is the deposit refundable?", answer: "Deposits are non-refundable but are applied toward your final invoice." },
  { _id: "f3", question: "What is your cancellation policy?", answer: "Reschedules require 12 hours notice (based on availability). Cancellations require 24 hours notice. Deposits remain non-refundable." },
  { _id: "f4", question: "Do you work outside Hampton Roads?", answer: "Yes — Upper Crest Image serves clients nationwide with a strong focus on Hampton Roads, VA." },
  { _id: "f5", question: "Are packages customized?", answer: "Yes. Every engagement is customized per client following an initial consultation." },
];

export default function FAQPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/faqs").then((r) => setItems(r.data.length ? r.data : FALLBACK_FAQS)).catch(() => setItems(FALLBACK_FAQS));
  }, []);

  return (
    <div data-testid="faq-page">
      <section className="max-w-[1100px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-12">
        <div className="eyebrow text-[var(--crest-gold)]">— Frequently Asked</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02]">Questions, answered.</h1>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 md:px-10 pb-32 divide-y divide-black/10 border-y border-black/10">
        {items.map((f) => {
          const expanded = open === f._id;
          return (
            <button
              key={f._id}
              onClick={() => setOpen(expanded ? null : f._id)}
              className="w-full text-left py-8 grid grid-cols-12 gap-6 items-start hover:bg-white/40 transition-colors"
              data-testid={`faq-row-${f._id}`}
            >
              <div className="col-span-10">
                <div className="font-serif text-2xl md:text-3xl tracking-tight">{f.question}</div>
                {expanded && <p className="text-[var(--crest-muted)] mt-4 leading-relaxed max-w-3xl">{f.answer}</p>}
              </div>
              <div className="col-span-2 text-right">
                {expanded ? <Minus size={20} className="ml-auto" style={{ color: "var(--crest-gold)" }} /> : <Plus size={20} className="ml-auto" style={{ color: "var(--crest-gold)" }} />}
              </div>
            </button>
          );
        })}
      </section>
    </div>
  );
}
